import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarAlt,
  faEnvelope,
  faImage,
  faUsers,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';

import { Container, Menu, MenuIcon } from './styles';

const menuItems = [
  { name: 'Eventos', path: '/panel/', icon: faCalendarAlt },
  { name: 'Criar Publicação', path: '/panel/create-post', icon: faImage },
  { name: 'Divulgadores favoritos', path: '/panel/promoters', icon: faUsers },
  { name: 'Solicitações de divulgação', path: '/panel/requests', icon: faEnvelope },
];

export default class Sidebar extends Component {
  state = {
    menuActive: false,
  };

  handleLogout = (e) => {
    e.preventDefault();

    window.localStorage.removeItem('token_producer');
    window.location.href = '/auth';
  };

  toggleMenu = () => {
    this.setState(prevState => ({
      menuActive: !prevState.menuActive,
    }));
  }

  render() {
    const { menuActive } = this.state;

    return (
      <Fragment>
        <MenuIcon onClick={() => this.toggleMenu()}>
          <div className="bar" />
          <div className="bar" />
          <div className="bar" />
        </MenuIcon>
        <Container className={`main-sidebar ${menuActive ? 'active' : ''}`}>
          <Menu onClick={() => this.toggleMenu()}>
            {menuItems.map(item => (
              <li key={item.name}>
                <Link to={item.path}>
                  <span className="item-icon">
                    <FontAwesomeIcon icon={item.icon} />
                  </span>
                  <span className="item-name">{item.name}</span>
                </Link>
              </li>
            ))}
            <li>
              <a href="/logout" onClick={this.handleLogout}>
                <span className="item-icon">
                  <FontAwesomeIcon icon={faSignOutAlt} />
                </span>
                <span className="item-name">Sair</span>
              </a>
            </li>
          </Menu>
        </Container>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js